export default __webpack_public_path__ + "static/media/toy9.ad53707e.jpg";